import(/* webpackMode: "eager" */ "/home/jubalj/builds/babyportal/node_modules/next/dist/client/app-dir/link.js");
